module.exports = __webpack_public_path__ + "static/media/8-10.2835d647.mp3";